import { Mail, Phone, MapPin, Facebook, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-navy-primary text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-10">

          {/* About */}
          <div className="lg:col-start-1 lg:row-start-1">
            <h3 className="font-playfair text-2xl font-bold mb-4">Conference</h3>
            <p className="font-montserrat text-gray-300 leading-relaxed">
              Connecting leaders, innovators, and professionals across industries.
            </p>
          </div>

          {/* Quick Links */}
          <div className="lg:col-start-2 lg:row-start-1">
            <h4 className="font-montserrat font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2 font-montserrat text-gray-300">
              <li>
                <a href="#about" className="hover:text-accent-orange transition-colors duration-300">
                  About
                </a>
              </li>

              {/* <li>
                <a href="#formats" className="hover:text-accent-orange transition-colors duration-300">
                  Formats
                </a>
              </li> */}

              <li>
                <a href="#events" className="hover:text-accent-orange transition-colors duration-300">
                  Events
                </a>
              </li>

              <li>
                <a href="#partners" className="hover:text-accent-orange transition-colors duration-300">
                  Partners
                </a>
              </li>

              <li>
                <a href="#faq" className="hover:text-accent-orange transition-colors duration-300">
                  FAQ
                </a>
              </li>
              {/* 
              <li>
                <a href="#contact" className="hover:text-accent-orange transition-colors duration-300">
                  Contact
                </a>
              </li> */}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="lg:col-start-4 lg:row-start-1">
            <h4 className="font-montserrat font-bold text-lg mb-4">Get In Touch</h4>
            <div className="space-y-3 font-montserrat text-gray-300">
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-accent-orange flex-shrink-0 mt-0.5" />
                <a
                  href="mailto:zeroclubco7@gmail.com"
                  className="hover:text-accent-orange transition-colors"
                >
                  zeroclubco7@gmail.com
                </a>
              </div>
              <div className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-accent-orange flex-shrink-0 mt-0.5" />
                <a
                  href="tel:+420732231653"
                  className="hover:text-accent-orange transition-colors"
                >
                  +420 732 231 653
                </a>
              </div>

              <div className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-accent-orange flex-shrink-0 mt-0.5" />
                <a
                  href="https://www.google.com/maps/place/603+00+Brno+3,+%D0%A7%D0%B5%D1%85%D1%96%D1%8F/@49.1886906,16.5683659,2823m/data=!3m1!1e3!4m6!3m5!1s0x47129433542d19d3:0x1c00af129863de30!8m2!3d49.1885614!4d16.5718181!16s%2Fg%2F1wbrwhwg?entry=ttu&g_ep=EgoyMDI1MTExMS4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-accent-orange transition-colors"
                >
                  Výstaviště 603 00 Brno-střed,<br />
                  Czech Republic
                </a>
              </div>

            </div>
          </div>
        </div>


        {/* Divider */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-6">
            {/* Copyright */}
            <p className="font-montserrat text-gray-400 text-sm">
              © 2025 ZeroClub. All rights reserved.
            </p>

            {/* Social Media */}
            <div className="flex gap-6">
              <a
                href="https://www.instagram.com/zeroclub__"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="relative z-10 inline-flex items-center hover:text-accent-orange transition-colors pointer-events-auto"
              >
                <Instagram size={26} className="pointer-events-none" />
              </a>
              <a
                href="https://www.facebook.com/people/ZEROclub/61579936142622"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="relative z-10 inline-flex items-center hover:text-accent-orange transition-colors pointer-events-auto"
              >
                <Facebook size={22} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
